import React, { Component } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import { addToHistory } from 'src/utils/utilsActions';
import DocUploadPres from 'src/ui/features/Documents/presentational/DocUploadPres';
import { isCorpClientSelector, isApplicantSelector, isCorporateClientLineManagerSelector } from 'src/ui/features/Login/state/loginReselect';
import {
  DOCUMENT_SUPPORTED_FILES,
  DOCUMENT_UPLOAD_TOTAL_MAX_SIZE,
  DOCUMENT_UPLOAD_MAX_NUM,
  DOC_UPLOAD_TYPES,
} from 'src/constants/constants';
import { PageTitle } from 'src/ui/library/PageTitle';
import {
  getDocumentsUploadFormAPI,
  uploadDocumentsFormAPI,
  getCaseLookupValuesAPI,
  getCaseLookupByCaseNumber,
} from 'src/services/documents.service';
import { fetchTypeSubTypeDropdownOptions } from 'src/services/contentparser.service.js';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { showNotification } from 'src/utils/utilsActions';
import { transformFormValues } from 'src/helpers';
import cloneDeep from 'lodash/cloneDeep';
import { withSnackbar } from 'notistack';
import { fnShowNewDashboard } from 'src/helpers/commonFunctions';
import _ from 'lodash';

class DocUploadContainer extends Component {
  initialState = {
    documents: [],
    formData: new FormData(),
    rejected: [],
    clientId: null,
    show: [],
    uploadedSize: 0,
    numOfFilesUploaded: 0,
    multiSelectExceeded: false,
    metaValid: [],
    progress: null,
    del: [],
    enableDel: false,
    confirmDialogState: false,
    isLoading: true,
    callFailes: true,
    documentsFormData: [],
    documentsFormDataModified: [],
    documentsFormDataSimplified: [],
    countryId: null,
    isCaseSelected: false,
    documentUploadFor: [],
    isCorporateUserExclusion: [],
  };

  constructor(props) {
    super(props);
    const { taskFlowProps, match } = props;

    this.state = {
      ...cloneDeep(this.initialState),
      caseId: taskFlowProps ? taskFlowProps.caseId : match ? match.params.caseId : null,
      dependentId: taskFlowProps ? taskFlowProps.dependentId : null,
      isTaskFlow: taskFlowProps ? true : false,
      selectedCases: {},
    };
  }

  componentDidMount = async () => {
    this.props.addToHistory(window.location.pathname);
    const results = await Promise.all([this.getDocumentForm(), this.getCaseLookupValues()]);

    if (results) {
      this.setState({ isLoading: false });
    }
  };

  getDocumentForm = () => {
    const { isTaskFlow } = this.state;
    const { history } = this.props;

    return getDocumentsUploadFormAPI().then(res => {
      if (res && !res.error && !res.errors) {
        this.setState({ initDocumentsFormData: res });
      } else {
        this.props.showNotification(intl.get('documents.notifications.uploadError'), { variant: 'error' });
        isTaskFlow ? this.setState({ ...cloneDeep(this.initialState), isLoading: false }) : history.goBack();
      }
    });
  };

  getCaseLookupValues = () => {
    const { isTaskFlow } = this.state;
    const { history } = this.props;

    return getCaseLookupValuesAPI(null, this.state.caseId, !isTaskFlow).then(res => {
      if (res && !res.error && !res.errors) {
        this.setState({ caseLookupValues: res });
      } else {
        this.props.showNotification(intl.get('documents.notifications.uploadError'), { variant: 'error' });
        isTaskFlow ? this.setState({ ...cloneDeep(this.initialState), isLoading: false }) : history.goBack();
      }
    });
  };

  componentDidUpdate(prevProps) {
    const { isCorpClient, documentFields } = this.props;

    if (!this.state.isUpdated && prevProps.documentFields !== documentFields) {
      this.setState({ isUpdated: true });
      documentFields.forEach((item, i) => {
        if (item) {
          this.updateCheckbox(i, isCorpClient);
        }
      });
    }
  }

  toggleDelete = (i, e) => {
    const del = this.state.del.slice();
    let enableDel = false;

    del[i] = e.target.checked;

    for (let i of del) {
      if (i) {
        enableDel = true;
      }
    }

    this.setState({ del, enableDel });
  };

  delUpload = e => {
    e.preventDefault();

    const { del, show, documents, documentsFormData, documentsFormDataModified } = this.state;

    let toRemove = [];
    for (let i = 0; i < del.length; i++) {
      if (del[i]) {
        toRemove.push(i);
      }
    }

    this.setState({
      documents: documents.filter((value, index) => {
        return !toRemove.includes(index);
      }),
      documentsFormData: documentsFormData.filter((value, index) => {
        return !toRemove.includes(index);
      }),
      documentsFormDataModified: documentsFormDataModified.filter((value, index) => {
        return !toRemove.includes(index);
      }),
      show: show.filter((value, index) => {
        return !toRemove.includes(index);
      }),
      del: del.filter((value, index) => {
        return !toRemove.includes(index);
      }),
      enableDel: false,
    });
  };

  attachFiles = (files, rejectedFiles) => {
    const show = this.state.show.slice();
    const del = this.state.del.slice();
    const metaValid = this.state.metaValid.slice();
    const {
      uploadedSize,
      initDocumentsFormData,
      documentsFormData,
      documentsFormDataModified,
      documents,
      rejected,
      documentsFormDataSimplified,
      caseId,
      dependentId,
      selectedCases,
      caseLookupValues,
      documentUploadFor,
    } = this.state;
    let newUploadTotalSize = uploadedSize;
    if (documents.length + files.length > DOCUMENT_UPLOAD_MAX_NUM) {
      this.setState({
        multiSelectExceeded: true,
      });
      return; // do we need to update anything here? At least provide a notice rather than return silently
    }

    files.forEach((file, index) => {
      newUploadTotalSize += file.size;
      if (newUploadTotalSize <= DOCUMENT_UPLOAD_TOTAL_MAX_SIZE) {
        const docFormData = cloneDeep(initDocumentsFormData);
        if (caseId) {
          Object.values(caseLookupValues).forEach(value => {
            if (value.id === caseId) {
              selectedCases[index] = [{ value: value.id, label: value.name, employeeId: value.props.employeeId }];
            }
          });
        }

        docFormData.pageElements.forEach(el => {
          if (el.attributeName === 'ey_documentname') {
            el.value = file.name;
          } else if (el.attributeName === 'ey_contactid') {
            el.value =
              selectedCases[index] && selectedCases[index].length && selectedCases[index][0].employeeId
                ? `${selectedCases[index][0].employeeId}|contact`
                : el.value;
          } else if (el.attributeName === 'ey_dependentid') {
            el.value = dependentId ? `${dependentId}|contact` : el.value;
          }
        });

        let isCaseFieldEmpty = false;
        Object.keys(selectedCases).forEach(key => {
          if (selectedCases[key].length <= 0) {
            isCaseFieldEmpty = true;
          }
        });
        this.setState({ isCaseSelected: isCaseFieldEmpty });
        documentUploadFor[documentsFormData.length] = DOC_UPLOAD_TYPES.CASE;
        documents.push(file);
        documentsFormData.push(docFormData);
        documentsFormDataModified.push(docFormData);
        documentsFormDataSimplified.push(docFormData);

        show.push('none');
        del.push(false);
        metaValid.push(false);
      } else {
        newUploadTotalSize -= file.size;
        rejected.push(file);
      }
    });

    var combinedRejectedFiles = Array.from(new Set([...rejectedFiles, ...rejected]));
    if (combinedRejectedFiles.length > 0) {
      var errorMsg = intl.get('documents.notifications.unsupportedFiles');
      this.props.showNotification(errorMsg, { variant: 'error' });
    }

    this.setState(prevState => ({
      uploadedSize: newUploadTotalSize,
      rejected: combinedRejectedFiles,
      multiSelectExceeded: false,
      documents,
      documentsFormData,
      documentsFormDataModified,
      show,
      del,
      metaValid,
    }));
  };

  removeUnsupportedFile(file) {
    let remaining = this.state.rejected.reduce((total, current) => (current !== file ? [...total, current] : total), []);
    this.setState({ rejected: remaining, progress: 0 });
  }

  finish = async () => {
    const { history, requiredActionId /*isApplicant*/ } = this.props;
    const { documentsFormDataModified, documents, selectedCases, isTaskFlow, documentUploadFor } = this.state;

    let uploadedDocuments = [];
    let saveEntityRequests = [];
    let cases = [];

    for (var i = 0; i < documents.length; i++) {
      var file = documents[i];
      var contents = await this.toBase64(file);
      var base64Content = '';

      if (contents) {
        var contentParts = contents.split('base64,');
        if (contentParts.length > 1) base64Content = contentParts[1];
      }

      uploadedDocuments.push({
        fileName: file.name,
        content: base64Content,
      });
    }

    this.setState({ isLoading: true });

    documentsFormDataModified.forEach((doc, index) => {
      let transformedValues = transformFormValues(doc.formValues);
      if (this.state.caseId) {
        const { caseLookupValues } = this.state;
        transformedValues.dataRequests.push({
          value: caseLookupValues[0].props.employeeId + '|' + caseLookupValues[0].props.employeeName,
          attributeName: 'ey_contactid',
          entityName: 'contact',
        });
      }
      saveEntityRequests.push(transformedValues);
      cases.push(index in selectedCases ? selectedCases[index].map(c => ({ id: c.value, name: c.label })) : []);
    });
    uploadDocumentsFormAPI({ documents: uploadedDocuments, saveEntityRequests, cases, requiredActionId, uploadedTos: documentUploadFor })
      .then(
        res => {
          if (res && !res.error && !res.errors && !res.includes('504 Gateway Time-out')) {
            this.props.enqueueSnackbar('Upload successful', { variant: 'success' });
            this.props.closeUploadModal && this.props.closeUploadModal();
          } else {
            let errorMsg = ' - ';
            if (res.error) {
              errorMsg += res.error.message;
            } else if (res.errors) {
              res.errors.forEach(error => {
                errorMsg += error.message + '\n';
              });
            } else {
              errorMsg = '';
            }
            this.props.enqueueSnackbar('Upload failed - ' + errorMsg, { variant: 'error' });
          }
        },
        error => {
          this.props.enqueueSnackbar('Upload failed - ' + error.message, { variant: 'error' });
        },
      )
      .finally(() => {
        isTaskFlow ? this.setState({ ...cloneDeep(this.initialState), isLoading: false }) : history.goBack();
      });
  };

  isCase() {
    return !!(this.props.match && this.props.match.params && this.props.match.params.caseId);
  }

  toggleView = i => {
    const show = this.state.show.slice();

    if (this.state.show[i] === 'block') {
      show[i] = 'none';
    } else {
      show[i] = 'block';
    }

    this.setState({ show });
  };

  toBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  handleFormChange = async (data, i) => {
    let {
      documentsFormDataModified,
      documentsFormDataSimplified,
      documentsFormData,
      isCorporateUserExclusion,
      documentUploadFor,
    } = this.state;
    const {
      elementUpdated,
      formValues: { dataRequests, rawElements },
      id,
      event,
    } = data;
    if (elementUpdated) {
      const currentElement = dataRequests[elementUpdated];
      const currentType = currentElement && currentElement.includes('|') && currentElement.split('|')[1];
      const currentValue = currentElement && currentElement.includes('|') && currentElement.split('|')[0];
      if (currentType && (currentType === 'ey_country' || currentType === 'ey_documenttype')) {
        let parameters = [];
        if (currentType === 'ey_country') {
          parameters = [currentValue];
          this.setState({ countryId: currentValue });
        }
        if (currentType === 'ey_documenttype') {
          if (this.state.countryId) {
            parameters = [this.state.countryId, currentValue];
          }
        }
        await fetchTypeSubTypeDropdownOptions(...parameters)
          .then(response => {
            documentsFormData[i].refresh_Data = {
              id,
              event,
              isRefresh: true,
              isCorporateUserExclusion: response.isCorporateUserExclusion,
              isCaseDocument: documentUploadFor[i] === DOC_UPLOAD_TYPES.CASE,
            };
            if (currentType === 'ey_country') {
              documentsFormData[i].lookUps.ey_documenttype = response.cmsLookupResponse;
            } else if (currentType === 'ey_documenttype') {
              documentsFormData[i].lookUps.ey_documentsubtypeid = response.cmsLookupResponse;
            }
            isCorporateUserExclusion[i] = response.isCorporateUserExclusion;
            this.setState({
              documentsFormData,
              isCorporateUserExclusion,
            });
          })
          .catch(error => {
            this.props.showNotification(intl.get('documents.notifications.uploadError'), { variant: 'error' });
          });
      }
      const dependentElement = rawElements.filter(x => x.attributeName === 'ey_dependentid');
      if (dependentElement.length > 0 && _.head(dependentElement).id === elementUpdated) {
        documentsFormData[i].refresh_Data = {
          id,
          event,
          isRefresh: true,
          isCorporateUserExclusion: isCorporateUserExclusion.length < i ? false : isCorporateUserExclusion[i],
          isCaseDocument: documentUploadFor[i] === DOC_UPLOAD_TYPES.CASE,
        };
      }
    }
    if (data.formValues.rawElements && Object.keys(data.formValues.rawElements).length > 0) {
      documentsFormDataModified[i] = data;
      documentsFormDataSimplified[i] = this.simplifyFormData(data);
    }

    this.setState({ documentsFormDataModified, documentsFormDataSimplified });
  };

  simplifyFormData = data => {
    const simplifiedData = {};
    if (data.formValues) {
      data.formValues.rawElements.forEach(el => {
        if (el.attributeName) {
          simplifiedData[el.attributeName] = el.props.value;
        }
      });
    }

    return simplifiedData;
  };

  isDisabled() {
    const { documentsFormDataModified } = this.state;
    if (!documentsFormDataModified.length) {
      return true;
    }

    if (documentsFormDataModified.length) {
      let foundEmptyRequiredField = false;
      documentsFormDataModified.forEach(doc => {
        if (doc && doc.formValues && doc.formValues.rawElements && doc.formValues.rawElements instanceof Array) {
          doc.formValues.rawElements.forEach(el => {
            if (el.props.value === '00000000-0000-0000-0000-000000000000|contact' || el.props.value === '|contact') {
              foundEmptyRequiredField = true;
            }
            if (el.props.required && !el.props.value && el.attributeName !== 'ownerid') {
              foundEmptyRequiredField = true;
            }
          });
        }
      });

      return foundEmptyRequiredField;
    }

    return false;
  }

  setConfirmDialogState = dialogState => {
    this.setState({
      confirmDialogState: dialogState,
    });
  };

  handleOnDocumentUploadFor = (isSelected, index) => {
    let { documentUploadFor, documentsFormData, isCorporateUserExclusion } = this.state;
    documentUploadFor[index] = isSelected ? DOC_UPLOAD_TYPES.CASE : DOC_UPLOAD_TYPES.PROFILE;
    documentsFormData[index].isCaseDocument = {
      isSelected: isSelected,
      isCorporateUserExclusion: isCorporateUserExclusion.length < index ? false : isCorporateUserExclusion[index],
    };
    this.setState({ documentUploadFor, documentsFormData });
  };

  handleCaseSelect = (index, val) => {
    let { selectedCases, documentsFormData, documentsFormDataModified, isCorporateUserExclusion, documentUploadFor } = this.state;
    const { documentsFormDataSimplified } = this.state;

    if (documentsFormData.length > 1 && index === 0) {
      for (let i = 0; i < documentsFormData.length; i++) {
        selectedCases[i] = val;
      }
    } else {
      selectedCases[index] = val;
    }
    let isCaseFieldEmpty = false;
    Object.keys(selectedCases).forEach(key => {
      if (selectedCases[key].length <= 0) {
        isCaseFieldEmpty = true;
      }
    });
    this.setState({ isCaseSelected: isCaseFieldEmpty });

    documentsFormData[index].pageElements.forEach(el => {
      if (el.attributeName === 'ey_contactid') {
        var employeeId = val.length ? val[0].employeeId : '';
        if (val.length > 1) {
          val.forEach(selectedCase => {
            if (selectedCase.employeeId !== employeeId) {
              employeeId = '';
            }
          });
        }
        documentsFormDataModified[index].formValues.rawElements.forEach(el => {
          if (el.attributeName === 'ey_contactid') {
            el.props.value = `${employeeId}|contact`;
          }
        });
        el.value = `${employeeId}|contact`;
      } else {
        el.value = documentsFormDataSimplified[index][el.attributeName];
      }
    });
    documentsFormData[index].isCaseDocument = {
      isSelected: documentUploadFor[index] === DOC_UPLOAD_TYPES.CASE,
      isCorporateUserExclusion: isCorporateUserExclusion.length < index ? false : isCorporateUserExclusion[index],
    };

    this.setState({
      selectedCases,
      documentsFormData,
      documentsFormDataModified,
    });
  };

  requestCase = async val => {
    let isPresent = this.state.caseLookupValues.filter(item => item.name.toLowerCase().includes(val.toLowerCase()));
    if (isPresent.length > 0) {
      return isPresent.map(c => ({ value: c.id, label: c.name, employeeId: c.props.employeeId }));
    } else {
      const result = await getCaseLookupByCaseNumber(val);
      return result.map(c => ({ value: c.id, label: c.name, employeeId: c.props.employeeId }));
    }
  };

  render() {
    const { isLoading } = this.state;
    // let isDefaultOldView = fnIsDefaultOldView();

    if (isLoading) {
      return (
        <div style={{ marginTop: '10%', marginBottom: '10%' }}>
          <Spinner size={70} />
        </div>
      );
    } else {
      return (
        <React.Fragment>
          <div className={fnShowNewDashboard() ? 'document-upload-new-dashboard' : null}>
            <PageTitle title={intl.get('documents.documentUpload.pageTitle')} />
            <DocUploadPres
              maxSize={DOCUMENT_UPLOAD_TOTAL_MAX_SIZE}
              multiSelectExceeded={this.state.multiSelectExceeded}
              progress={this.state.progress}
              attachFiles={this.attachFiles}
              documents={this.state.documents}
              rejected={this.state.rejected}
              finish={this.finish.bind(this)}
              removeUnsupportedFile={file => this.removeUnsupportedFile(file)}
              acceptedFileTypes={DOCUMENT_SUPPORTED_FILES.join(',')}
              isCase={this.state.caseId ? true : false}
              show={this.state.show}
              del={this.state.del}
              toggleView={this.toggleView}
              toggleDelete={this.toggleDelete}
              delUpload={this.delUpload}
              enableDel={this.state.enableDel}
              showConfirmDialog={this.setConfirmDialogState.bind(this, true)}
              hideConfirmDialog={this.setConfirmDialogState.bind(this, false)}
              confirmDialogState={this.state.confirmDialogState}
              caseLookupValues={this.state.caseLookupValues}
              documentsFormData={this.state.documentsFormData}
              documentsFormDataSimplified={this.state.documentsFormDataSimplified}
              initDocumentsFormData={this.state.initDocumentsFormData}
              onFormChange={this.handleFormChange}
              onCaseSelect={this.handleCaseSelect}
              isDisabled={this.isDisabled()}
              selectedCases={this.state.selectedCases}
              isTaskFlow={this.state.isTaskFlow}
              isCaseSelected={this.state.isTaskFlow ? true : this.state.isCaseSelected}
              requestCase={this.requestCase}
              selectedCase={this.state.caseId}
              documentUploadFor={this.state.documentUploadFor}
              handleOnDocumentUploadFor={this.handleOnDocumentUploadFor}
              {...this.props}
            />
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = ({ documents: { clients, documentTypes, employees, documentFields, documentIds, filters }, ...state }) => ({
  clients,
  documentTypes,
  employees,
  documentFields,
  documentIds,
  filters,
  isCorpClient: isCorpClientSelector(state),
  isApplicant: isApplicantSelector(state),
  isCcLineManager: isCorporateClientLineManagerSelector(state),
  applicantId: state.login.userInfo.personId,
  cases: state.cases.tableData.cases || [],
});

const mapDispatchToProps = {
  addToHistory,
  showNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(DocUploadContainer));
